import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { CrmContactsDataGrid } from "src/components/views/erp/sales/crm/contacts/CrmContactsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/crm/contacts")({
	staticData: { title: i18n.t("contacts"), legacyViewKey: "crmContactsView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <CrmContactsDataGrid />;
}
